export const REQUEST_PLANS = 'REQUEST_PLANS';
export const RECEIVE_PLANS = 'RECEIVE_PLANS';
export const PLANS_REQUEST_FAILED = 'PLANS_REQUEST_FAILED';
export const DELETE_PLAN_REQUESTED = 'DELETE_PLAN_REQUESTED';
export const DELETE_PLAN_REQUEST_COMPLETED = 'DELETE_PLAN_REQUEST_COMPLETED';
export const DELETE_PLAN_REQUEST_FAILED = 'DELETE_PLAN_REQUEST_FAILED';
export const RESET_PLANS_VIEW_STATE = 'RESET_PLANS_VIEW_STATE';
export const PLANS_TOGGLE_ONE_ORG_PLANS = 'PLANS_TOGGLE_ONE_ORG_PLANS';
